<template>
  <div class="k3">
    <div class="fullPage" ref="fullPage">
      <div class="fullPageContainer" ref="fullPageContainer">
        <div class="section section1">
          <!-- <Header v-show="!minip" @forbid="forbid" @open="open"/> 
           <Onepage @showCover="showCover" :clientPosition="clientPosition" /> -->
          <!-- 不传递定位 -->
          <!-- EV5 -->
          <Onepage @showCover="showCover" :clientPosition="clientPosition"/>
          <!-- 索奈 -->
          <!-- <Sonetpage @showCover="showCover" :clientPosition="clientPosition"></Sonetpage> -->
        </div>
      </div>
      <!-- <div class="cover" :class="{'cover-show': isShowCover}">
        <MyForm @hideCover="showCover(false)"></MyForm>
      </div>
      <div class="cover2" v-if="isShowCover"></div> -->
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Onepage from "./components/Onepage";
import Sonetpage from "./components/Sonetpage";
import MyForm from "@/components/My-Form";
import { isPortraitFun } from "@/utils/utils.js";
import $ from 'jquery'

export default {
  name:'K3MOB ',
  components: { Header,Sonetpage,Onepage,MyForm },
  data() {
    return {
      checked:false,
      isPortrait: isPortraitFun(),
      flag: false,
      isShowCover: false, // 显示留资弹窗
      // 地图类
      BMap: false,
      clientPosition: null,
    };
  },
  mounted: function () {
    this.cutLocal()
  },
  methods: {
    // 显示弹窗组件
    showCover(flag) {
      console.log("显示留资弹窗",flag);
      this.isShowCover = flag
      this.flag = flag
    },
    // 定位城市
    load() {
      return new Promise((resolve, reject) => {
        if (!this.BMap) {
          $.getScript('//api.map.baidu.com/api?v=2.0&ak=4ybCJ1rBffkf2PFgkvsRJuqAV9XBtnHq&callback=initialize', function (res) {
            console.log("百度",res);
            let num = 1
              let time = setInterval(() => {
                if (BMap.Map) {
                  this.BMap = true
                  resolve(BMap)
                  clearInterval(time)
                }
                num++
              }, 25)
          })
        } else {
          resolve(BMap)
        }
      })
    },
    async cutLocal() {
      let map = await this.load()
      let _this = this
      if(map.Map) {
        let funL = new map.Geolocation()
        funL.getCurrentPosition((res) => {
          // 如果存在经纬度
          if(res.point) {
            var myGeo = new map.Geocoder();
            myGeo.getLocation(new map.Point(res.point.lng, res.point.lat), function(result) {
              const params = Object.assign({
                lng: res.point.lng,
                lat: res.point.lat
              }, result.addressComponents)
              console.log(params);
              _this.clientPosition = params
            })
          }
        }, (err) => {
          console.log(err)
        })
      }
    },

  },
  created: function () {

  },
}

</script>

<style lang="scss" scoped>

</style>
